/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import {
  MenuItem,
  TextField,
  Grid,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@material-ui/core";
export default function CompleteDisputeOrderActionsSection(props) {

 
  const { orderDisputedItemsActionsData = [] } = props.rows;

  const [disputeActionType, setDisputeActionType] = useState();
  const [disputeItemRewardType, setDisputeItemRewardType] = useState("1");
  const [disputeItemReward, setDisputeItemReward] = useState("");
  const [disputeActionRemarks, setDisputeActionRemarks] = useState("");

  const handleChange = (event, maxValue) => {
    // Call the function with the value of the selected radio button

    const { name, value } = event.target;
    let isValid = true;

    if (name == "disputeActionType") {
      setDisputeActionType(value);

      setDisputeItemReward("");
      props.onDisputeHandleChange({
        target: {
          name: "disputeItemReward",
          // eslint-disable-next-line react/prop-types
          value: { actionValue: "", recordId: props.rows.disputedId, isComplete:1 },
        },
      });

      setDisputeItemRewardType("1");
      props.onDisputeHandleChange({
        target: {
          name: "disputeItemRewardType",
          // eslint-disable-next-line react/prop-types
          value: { actionValue: "1", recordId: props.rows.disputedId ,isComplete:1 },
        },
      });

      setDisputeActionRemarks("");
      props.onDisputeHandleChange({
        target: {
          name: "disputeActionRemarks",
          // eslint-disable-next-line react/prop-types
          value: { actionValue: "", recordId: props.rows.disputedId ,isComplete:1},
        },
      });
    } else if (name == "disputeItemRewardType") {
      setDisputeItemRewardType(value);

      setDisputeItemReward("");
      props.onDisputeHandleChange({
        target: {
          name: "disputeItemReward",
          // eslint-disable-next-line react/prop-types
          value: { actionValue: "", recordId: props.rows.disputedId, isComplete:1 },
        },
      });
    } else if (name == "disputeItemReward") {
      if (disputeItemRewardType == 2 && value && (value == 0 || value > 100)) {
        isValid = false;
        props.handleSnackbar(
          true,
          `Percentage can't be 0% or greater than 100%`,
          "error"
        );
        // alert("In percentage can't be 0 and greater than 100");
      } else if (
        disputeItemRewardType == 1 &&
        value &&
        (value == 0 || value > maxValue)
      ) {
        isValid = false;
        props.handleSnackbar(
          true,
          `Amount can't be 0 or greater than ${maxValue}`,
          "error"
        );
        // alert(`In Amount can't be 0 and greater than ${maxValue}`);
      } else {
        setDisputeItemReward(value);
      }
    } else if (name == "disputeActionRemarks") {
      setDisputeActionRemarks(value);
    }

    if (isValid) {
      props.onDisputeHandleChange({
        target: {
          name,
          // eslint-disable-next-line react/prop-types
          value: { actionValue: value, recordId: props.rows.disputedId,isComplete:1},
        },
      });
    }
  };

  return (
    <>
      <Grid item xs={4}>
        <TextField
          title="Dispute Item Action"
          label="Dispute Item Action"
          name="disputeActionType"
          value={disputeActionType}
          onChange={handleChange}
          variant="outlined"
          color="primary"
          fullWidth
          select
        >
          {orderDisputedItemsActionsData.map((item) => {
            return (
              <MenuItem key={item} value={item.id}>
                {item.label || "N/A"}
              </MenuItem>
            );
          })}
        </TextField>
      </Grid>
      {disputeActionType == 3 && (
        <Grid item xs={3}>
          <FormControl component="fieldset">
            <RadioGroup
              row
              aria-label="disputeItemRewardType"
              name="disputeItemRewardType"
              value={disputeItemRewardType}
              onChange={handleChange}
            >
              <FormControlLabel
                value={"1"}
                control={<Radio color="primary" />}
                label="In Amount"
                labelPlacement="end"
              />
              <FormControlLabel
                value={"2"}
                control={<Radio color="primary" />}
                label="In Percentage"
                labelPlacement="end"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      )}
      {disputeActionType == 3 && (
        <Grid item xs={5}>
          <TextField
            title="Dispute Item Reward"
            label="Dispute Item Reward"
            type="number"
            name="disputeItemReward"
            value={disputeItemReward}
            onChange={(e) => handleChange(e, props.rows.totalItemNetAmount || 0)}
            variant="outlined"
            color="primary"
            fullWidth
            InputProps={{
              endAdornment: (
                <>
                  {disputeItemRewardType == 2 ? (
                    <b>/100% ({props.rows.totalItemNetAmount || 0})</b>
                  ) : (
                    <b>
                      /
                      {(props.rows.totalItemNetAmount || 0) -
                        (disputeItemReward || 0)}
                    </b>
                  )}
                </>
              ),
            }}
          />
        </Grid>
      )}
      <Grid item xs={disputeActionType == 3 ? 12 : 8}>
        <TextField
          name="disputeActionRemarks"
          variant="outlined"
          label="Action Remarks"
          value={disputeActionRemarks}
          fullWidth
          onChange={handleChange}
        />
      </Grid>
    </>
  );
}
